// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"InputNumber_inputWrapper__26Bcd","inputWrapperNoNumber":"InputNumber_inputWrapperNoNumber__3_Biq","wsaInput":"InputNumber_wsaInput__34R2E"};